import {Component, Input, OnInit} from '@angular/core'
import {PUBLIC_ROUTES} from '../../../routing/public.routes'
import {LinkService, OTHER_OFFERING_ID} from '../../../../core/i18n/link.service'
import {ApplicationRoute} from '../../../../craft/utils/application.route'
import {OfferingsSection, OfferingsSectionItem} from '../../../../core/content/types/offering-section.types'
import {TranslocoDirective, TranslocoService} from '@ngneat/transloco'
import {toTwoDimensionalArray} from '../../../../core/utils/array-utils'
import {Params, RouterLink} from '@angular/router'
import {CardsModule} from '../../../../craft/cards/cards.module'
import {SliderModule} from '../../../../craft/slider/slider.module'
import {ContentSectionComponent} from '../../../../craft/content-section/content-section.component'

@Component({
  selector: 'bgo-offerings-section',
  templateUrl: './offerings-section.component.html',
  styles: [':host { display: block }'],
  imports: [ContentSectionComponent, CardsModule, RouterLink, SliderModule, TranslocoDirective],
})
export class OfferingsSectionComponent implements OnInit {
  @Input() offeringsSection!: OfferingsSection
  @Input() titleAlignment: 'left' | 'center' = 'center'
  @Input() showOtherJobRequestCard = true
  @Input() showOtherJobRequestSection = false
  @Input() targetQueryParams?: Params

  columns!: OfferingsSectionItem[][]

  readonly otherJobRequestIcon = {collection: 'fal', name: 'ellipsis-h'}
  readonly otherJobRequestPath: string

  constructor(
    private readonly linkService: LinkService,
    private readonly translocoService: TranslocoService,
  ) {
    this.otherJobRequestPath = linkService.localizedPathTo(PUBLIC_ROUTES.JOB_REQUEST, {
      routeParams: {offeringId: OTHER_OFFERING_ID},
    })
  }

  ngOnInit(): void {
    if (this.showOtherJobRequestCard) {
      this.offeringsSection.items.push({
        title: this.translocoService.translate('offeringSection.otherJobRequest'),
        description: this.translocoService.translate('offeringSection.jobRequestCallToAction'),
        icon: this.otherJobRequestIcon,
        targetPath: this.otherJobRequestPath,
        targetType: 'job-request',
      })
    }

    this.columns = toTwoDimensionalArray(this.offeringsSection.items, 3)
  }

  navigate(targetPath: string): void {
    this.linkService.navigateTo(new ApplicationRoute(targetPath), {queryParams: this.targetQueryParams})
  }
}
